import { motion } from "framer-motion";
import { MapPin, ArrowUpRight } from "lucide-react";
import { OFFICE_IMAGES } from "../data/services";
import { WHATSAPP_URL } from "../i18n/translations";

export const Offices = ({ t }) => {
  const offices = [
    { key: "caracas", testid: "office-card-caracas", image: OFFICE_IMAGES.caracas, ...t.offices.caracas },
    { key: "croton", testid: "office-card-croton", image: OFFICE_IMAGES.croton, ...t.offices.croton },
  ];

  return (
    <section id="offices" data-testid="offices-section" className="scroll-mt-24 border-t border-white/10 bg-[#0C1018] px-5 py-24 sm:px-8 sm:py-32">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14 max-w-2xl"
        >
          <span className="text-xs font-semibold uppercase tracking-[0.28em] text-amber-400">{t.offices.eyebrow}</span>
          <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">{t.offices.title}</h2>
          <p className="mt-4 text-base text-slate-400 sm:text-lg">{t.offices.sub}</p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-2">
          {offices.map((o, i) => (
            <motion.div
              key={o.key}
              data-testid={o.testid}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="group relative overflow-hidden rounded-2xl border border-white/10"
            >
              <img
                src={o.image}
                alt={o.city}
                loading="lazy"
                className="h-80 w-full object-cover opacity-40 transition-transform duration-[1.2s] ease-out group-hover:scale-105 sm:h-96"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D14] via-[#0A0D14]/60 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-7">
                <span className="text-[11px] font-bold uppercase tracking-[0.24em] text-amber-400">{o.tag}</span>
                <h3 className="font-display mt-2 text-2xl font-bold text-white sm:text-3xl">
                  {o.city} <span className="text-slate-400">· {o.country}</span>
                </h3>
                <p className="mt-2 flex items-center gap-2 text-sm text-slate-300">
                  <MapPin className="h-4 w-4 shrink-0 text-amber-400" />
                  {o.address}
                </p>
                <a
                  data-testid={`${o.testid}-whatsapp-link`}
                  href={`${WHATSAPP_URL}?text=${encodeURIComponent(t.whatsapp_prefill)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-300 transition-colors duration-300 hover:text-amber-200"
                >
                  {t.offices.cta}
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
